export interface ITransactionProductInput {
  id: number;
  regex: string;
  label: string;
  description: string;
  min_length: number;
  max_length: number;
}

export interface ITransactionProductCategory {
  id: number;
  name: string;
  description: string;
  image: string;
  localizable_name: string;
}

export interface ITransactionProduct {
  id: number;
  name: string;
  description: string;
  image: string;
  provider_sku: string;
  inputs: ITransactionProductInput[];
  categories: ITransactionProductCategory[];
  price: string;
  surcharge: string;
  total: string;
  show_usa_user: boolean;
  show_mx_user: boolean;
  redeemable_in_usa: boolean;
  redeemable_in_mx: boolean;
}

export enum TransactionTypeIds {
  PURCHASE = 2,
  TRANSFER = 3,
  DEPOSIT = 1,
  REIMBURSE = 4,
  BP_REWARD = 6
}

export interface ITransactionStatus {
  status_name: string;
  localizable_name: string;
}

export interface ITransactionType {
  id: TransactionTypeIds | null;
  name: string;
  localized_name: string;
}

export type TransactionSource = 'transaction' | 'deposit';

export interface ITransaction {
  id: number | null;
  source: TransactionSource;
  user: number;
  amount: string;
  amount_display: string;
  counterpart: any;
  name_en: string;
  name_es: string;
  purchase: any | null;
  status: ITransactionStatus;
  status_display: string;
  timestamp?: string | null;
  timestamp_display: string;
  event_date?: string | null;
  earned_month?: string | null;
  maturity?: string | null;
  transaction_title: string;
  transaction_type: ITransactionType;
  product?: ITransactionProduct;
}
